var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submissions_board",attrs:{"id":_vm.id},on:{"dragover":function($event){$event.preventDefault();},"drop":function($event){$event.preventDefault();return _vm.drop.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }